<p-card styleClass="p-card-shadow mt-2">
    <div class="card dashboardTable">
        <p-toolbar styleClass="mb-4">
            <ng-template pTemplate="left">
                <!-- <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                    class="p-button-success"></button> -->
                <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
            </ng-template>
            <ng-template pTemplate="right">
                <!-- <p-fileUpload accept=".jpeg,.pdf,.jpg" mode="basic" [maxFileSize]="5000000" label="Import" chooseLabel="Import" class="mr-2 inline-block"></p-fileUpload> -->
                <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-upload"
                    class="p-button-help"></button>
               
                <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
            </ng-template>
    
        </p-toolbar>
        <p-table #miSurvey [value]="districtWise"  dataKey="AppId_ProgID"
        [rows]="10"
        [globalFilterFields]="[
        'District',
        'TotalApplication',
        'VerifiedApplication',
        'BOQAmount',
        'Mi_Area',
        
        
        ]" responsiveLayout="scroll" [rowHover]="true" dataKey="Scheme_Specific_Id"
        [showCurrentPageReport]="true" [loading]="loading">
        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
                <h5 class="m-0">{{'DISTRICT_WISE_REPORT'| translate}}</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text"
                        (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                        placeholder="{{'SEARCH'| translate}}" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">

            <tr>
              
                
                <th pSortableColumn="District">{{'DISTRICT'| translate}}
                    <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                    <p-sortIcon field="District"></p-sortIcon>
                </th>
                <th pSortableColumn="TotalApplication">{{'TOTAL_APPLICATION'| translate}}
                    <p-columnFilter type="text" field="TotalApplication" display="menu"></p-columnFilter>
                    <p-sortIcon field="TotalApplication"></p-sortIcon>
                </th>
                <th pSortableColumn="VerifiedApplication">{{'VERIFIED_APPLICATION'| translate}}
                    <p-columnFilter type="text" field="VerifiedApplication" display="menu"></p-columnFilter>
                    <p-sortIcon field="VerifiedApplication"></p-sortIcon>
                </th>
                <th pSortableColumn="BOQAmount">{{'BOQ_AMOUNT'| translate}}
                    <p-columnFilter type="text" field="BOQAmount" display="menu"></p-columnFilter>
                    <p-sortIcon field="BOQAmount"></p-sortIcon>
                </th>
                <th pSortableColumn="Mi_Area">{{'MI_AREA'| translate}}
                    <p-columnFilter type="text" field="Mi_Area" display="menu"></p-columnFilter>
                    <p-sortIcon field="Mi_Area"></p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-districtWise>
            <tr>
                <td>{{districtWise.District}}</td>
                <td><a class="link_pointer" (click)="showMaximizableDialog_totalApp(districtWise.District)">{{districtWise.TotalApplication}}</a></td>
                <td><a class="link_pointer" (click)="showMaximizableDialog(districtWise.District,'Approved')">{{districtWise.VerifiedApplication}}</a></td>
                <td>{{districtWise.BOQAmount}}</td>
                <td>{{districtWise.Mi_Area}}</td>
                
            </tr>
        </ng-template>
        <ng-template pTemplate="footer">
            <tr>
                <td > Grand Total</td>
                <td >{{grandTotalApp | number:'1.0-2'}}</td>
                <td >{{grandVerfApp | number:'1.0-2'}}</td>
                <td >{{grandBoqAmount | number:'1.0-2'}}</td>
                <td >{{grandMiArea | number:'1.0-2'}}</td>
             </tr>
        </ng-template>
    
        </p-table>
    </div>
    </p-card>
    <p-dialog class="drilldown_details" [baseZIndex]="-100" header="Drill Down District wise BOQ Report Of Verified Application of {{value}} "  [(visible)]="displayMaximizable" [modal]="true" [style]="{width: '100%'}"  
    [draggable]="false" [resizable]="false" >
    
    <app-drill-down-approved-incomplete-report  *ngIf="displayMaximizable" [drilldownDetails]="drilldownDetails"></app-drill-down-approved-incomplete-report>
    
   </p-dialog>
   <p-dialog  class="drilldown_details" [baseZIndex]="-100" header="Drill Down District wise BOQ Report Of Total Application of {{value}} "  [(visible)]="displayMaximizable_totalApp" [modal]="true" [style]="{width: '100%'}"  
   [draggable]="false" [resizable]="false" >
   
   <app-drill-down-total-report  *ngIf="displayMaximizable_totalApp" [drilldownDetails]="drilldownDetails"></app-drill-down-total-report>
   
  </p-dialog>
    
